import {
  API_URL,
  v,
  put,
  debug,
  request,
  takeEvery,
  createDoRequestAction,
  assertTotalSchema,
  SagaIterator,
} from '../../lib'

import {doREQUEST_ERROR, doREQUEST_COMPLETE, doPROFILE_SET} from '../state'

export const VERIFY_PHONE_REGISTER = 'VERIFY_PHONE_REGISTER'
export const doVERIFY_PHONE_REGISTER = createDoRequestAction(VERIFY_PHONE_REGISTER)

export const verifyPhoneRegisterActionCreators = {
  doVERIFY_PHONE_REGISTER,
}

export function* verifyPhoneRegister({payload, setRequestResult}: any): SagaIterator {
  debug('saga*verifyPhoneRegister')
  try {
    assertTotalSchema({
      payload,
      schema: v.object({
        requestId: v.string().uuid().exist(),
        phoneNumber: v.number().exist(), // it's 'String' in API spec
        phoneCountryCode: v.number().exist(),
        verificationCode: v.string().exist(),
      }),
    })
  } catch (error) {
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: VERIFY_PHONE_REGISTER,
          requestId: payload.requestId,
          error,
        },
        setRequestResult,
      ),
    )
  }

  const {phoneNumber, phoneCountryCode, verificationCode} = payload

  const result = yield request({
    method: 'post',
    url: `${API_URL}/v1/web/identity-phone-register-verify`,
    data: {
      phoneNumber,
      phoneCountryCode,
      verificationCode,
    },
  })

  if (!result.success || result.error) {
    const error = result.error || new Error('request did not succeed')
    debug(error)

    return yield put(
      doREQUEST_ERROR(
        {
          fromType: VERIFY_PHONE_REGISTER,
          fromPayload: payload,
          requestId: payload.requestId,
          url: '/v1/web/identity-phone-register-verify',
          ...result,
          error,
        },
        setRequestResult,
      ),
    )
  }

  yield put(doPROFILE_SET(result.payload))

  yield put(
    doREQUEST_COMPLETE(
      {
        fromType: VERIFY_PHONE_REGISTER,
        requestId: payload.requestId,
        ...result,
      },
      setRequestResult,
    ),
  )
}

export function* verifyPhoneRegisterSaga() {
  yield takeEvery(VERIFY_PHONE_REGISTER, verifyPhoneRegister)
}
